import React, { useState, useEffect } from 'react';
import { GetDashboard, MonthlyDailyReport } from '../Services/Dashboard';
import Labimage from '../assets/labimg.png';
import Financeimage from '../assets/e.png';
import Sells from '../assets/pts.png';
import pendingTest from '../assets/pendingTest.png';
import Highcharts from 'highcharts';
import { useNavigate } from 'react-router-dom';
import '../UI/Dashboard.css';
import { toast } from 'react-toastify';
import moment from 'moment';
import SpinnerModal from '../Spinner/SpinnerModal';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    totalPatients: 0,
    totalTests: 0,
    totalSell: 0,
    pendingTestCount: 0
  });
  const [isLoading, setIsLoading] = useState(false);
  const [MonthlyReport, SetMonthlyReport] = useState([]);
  const [DailyReports, DailyReport] = useState([]);
  const navigate = useNavigate();

  const handleYearChange = (e) => {
    const selectedYear = e.target.value;
    getDashboardData(selectedYear);
    GetMonthlyDaily(selectedYear);
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    getDashboardData(currentYear);
    GetMonthlyDaily(currentYear);
  }, []);

  const getDashboardData = async (Year) => {
    try {
      setIsLoading(true);
      const LabID = sessionStorage.getItem('LabID');
      const response = await GetDashboard(LabID, Year);
      if (response) {
        setDashboardData(response);
      }
    } catch (error) {
      toast.error('Unable to get finance data: ' + (error?.message || 'Error occurred'));
    } finally {
      setIsLoading(false);
    }
  };

  const GetMonthlyDaily = async (YEAR) => {
    try {
      setIsLoading(true);
      const LabID = sessionStorage.getItem('LabID');
      const response = await MonthlyDailyReport(LabID, YEAR);
      if (response) {
        SetMonthlyReport(response.monthlyReports || []);
        DailyReport(response.dailyReports || []);
      }
    } catch (error) {
      toast.error('Unable to get status data: ' + (error?.message || 'Error occurred'));
    } finally {
      setIsLoading(false);
    }
  };

  // Highcharts Global Theme Configuration
  useEffect(() => {
    Highcharts.setOptions({
      colors: ['#2c6bd7', '#00bfff', '#104298', '#ffc107', '#dc3545'],
      chart: {
        backgroundColor: '#ffffff',
        style: {
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        },
        borderRadius: 8
      },
      title: {
        style: {
          color: '#1e293b',
          fontSize: '15px',
          fontWeight: '600'
        }
      },
      credits: { enabled: false },
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderWidth: 0,
        shadow: true,
        style: { fontSize: '12px' }
      }
    });
  }, []);

  // 1. Monthly Column Chart
  useEffect(() => {
    if (!MonthlyReport.length) return;

    const months = MonthlyReport.map((r) => r.monthName);
    const totalTests = MonthlyReport.map((r) => r.totalTest);
    const totalGrandTotals = MonthlyReport.map((r) => r.totalGrandTotal);
    const receivedAmounts = MonthlyReport.map((r) => r.receivedAmount);
    const dueAmounts = MonthlyReport.map((r) => r.dueAmount);
    const totalDiscounts = MonthlyReport.map((r) => r.totalDiscount);

    Highcharts.chart('Highchart-Container', {
      chart: { type: 'column' },
      title: {
        text: '<div className="d-flex justify-content-between align-items-center"><span>Monthly Overview</span> <a href="#" id="navigate-to-Monthly" class="common-Link common-FontSize-small">View Detailed Report &rarr;</a></div>',
        useHTML: true
      },
      xAxis: { categories: months, crosshair: true },
      yAxis: { min: 0, title: { text: 'Amount (PKR)' } },
      plotOptions: {
        column: { pointPadding: 0.15, borderWidth: 0, borderRadius: 3 }
      },
      series: [
        { name: 'Total Tests', data: totalTests },
        { name: 'Grand Total', data: totalGrandTotals },
        { name: 'Received Amount', data: receivedAmounts },
        { name: 'Due Amount', data: dueAmounts },
        { name: 'Total Discount', data: totalDiscounts }
      ]
    });

    const link = document.getElementById('navigate-to-Monthly');
    if (link) {
      const handler = (e) => {
        e.preventDefault();
        navigate('/Home/Reports');
      };
      link.addEventListener('click', handler);
      return () => link.removeEventListener('click', handler);
    }
  }, [MonthlyReport, navigate]);

  // 2. Daily Column Chart
  useEffect(() => {
    if (!DailyReports.length) return;

    const limitedReports = DailyReports.slice(0, 10);
    const categories = limitedReports.map((r) => moment(r.recordDate).format('DD/MM/YY'));
    const totalTests = limitedReports.map((r) => r.totalTest);
    const totalGrandTotals = limitedReports.map((r) => r.totalGrandTotal);
    const receivedAmounts = limitedReports.map((r) => r.receivedAmount);
    const dueAmounts = limitedReports.map((r) => r.dueAmount);
    const totalDiscounts = limitedReports.map((r) => r.totalDiscount);

    Highcharts.chart('Highchart-Daily-Container', {
      chart: { type: 'column' },
      title: {
        text: '<div className="d-flex justify-content-between align-items-center"><span>Daily Activity (Recent)</span> <a href="#" id="navigate-to-daily" class="common-Link common-FontSize-small">View Daily Report &rarr;</a></div>',
        useHTML: true
      },
      xAxis: { categories, crosshair: true },
      yAxis: { min: 0, title: { text: 'Amount (PKR)' } },
      plotOptions: {
        column: { pointPadding: 0.15, borderWidth: 0, borderRadius: 3 }
      },
      series: [
        { name: 'Total Tests', data: totalTests },
        { name: 'Grand Total', data: totalGrandTotals },
        { name: 'Received Amount', data: receivedAmounts },
        { name: 'Due Amount', data: dueAmounts },
        { name: 'Total Discount', data: totalDiscounts }
      ]
    });

    const link = document.getElementById('navigate-to-daily');
    if (link) {
      const handler = (e) => {
        e.preventDefault();
        navigate('/Home/Reports');
      };
      link.addEventListener('click', handler);
      return () => link.removeEventListener('click', handler);
    }
  }, [DailyReports, navigate]);

  // 3. Monthly Area-Spline Chart
  useEffect(() => {
    if (!MonthlyReport.length) return;

    const months = MonthlyReport.map((r) => r.monthName);
    Highcharts.chart('Highchart-Progress-container', {
      chart: { type: 'areaspline' },
      title: { text: 'Monthly Performance Trends' },
      xAxis: { categories: months },
      yAxis: { title: { text: 'Amount (PKR)' } },
      plotOptions: {
        areaspline: { fillOpacity: 0.15 }
      },
      series: [
        { name: 'Total Tests', data: MonthlyReport.map((r) => r.totalTest) },
        { name: 'Grand Total', data: MonthlyReport.map((r) => r.totalGrandTotal) },
        { name: 'Received Amount', data: MonthlyReport.map((r) => r.receivedAmount) },
        { name: 'Due Amount', data: MonthlyReport.map((r) => r.dueAmount) },
        { name: 'Total Discount', data: MonthlyReport.map((r) => r.totalDiscount) }
      ]
    });
  }, [MonthlyReport]);

  // 4. Monthly Distribution Pie Chart
  useEffect(() => {
    if (!MonthlyReport.length) return;

    const pieData = [
      { name: 'Total Tests', y: MonthlyReport.reduce((sum, r) => sum + r.totalTest, 0) },
      { name: 'Grand Total', y: MonthlyReport.reduce((sum, r) => sum + r.totalGrandTotal, 0) },
      { name: 'Received Amount', y: MonthlyReport.reduce((sum, r) => sum + r.receivedAmount, 0) },
      { name: 'Due Amount', y: MonthlyReport.reduce((sum, r) => sum + r.dueAmount, 0) },
      { name: 'Total Discount', y: MonthlyReport.reduce((sum, r) => sum + r.totalDiscount, 0) }
    ];

    Highcharts.chart('Highchart-pie-container', {
      chart: { type: 'pie' },
      title: { text: 'Annual Revenue & Activity Distribution' },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y:,.0f}'
          }
        }
      },
      series: [
        {
          name: 'Metrics',
          colorByPoint: true,
          data: pieData
        }
      ]
    });
  }, [MonthlyReport]);

  return (
    <>
      {isLoading && <SpinnerModal isLoading={true} />}
      <div className="container-fluid Container2 Dasboard-container px-4">
        {/* Header Bar */}
        <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
          <div>
            <h4 className="common-FontFamily common-color commont-Font-Bold m-0">Dashboard Overview</h4>
            <p className="common-FontFamily common-FontSize-small text-muted m-0">
              Real-time analytics and financial summaries
            </p>
          </div>
          <div className="d-flex align-items-center gap-2">
            <label className="common-Labels m-0">Filter Year:</label>
            <select
              className="form-select common-Input py-1 px-3"
              id="Year"
              name="Year"
              defaultValue="2026"
              onChange={handleYearChange}
              style={{ width: '130px' }}
            >
              <option value="2026">2026</option>
              <option value="2025">2025</option>
              <option value="2024">2024</option>
              <option value="2023">2023</option>
            </select>
          </div>
        </div>

        {/* Metric Cards Row */}
        <div className="row g-3 mb-4">
          <div className="col-12 col-sm-6 col-xl-3">
            <div className="dashboard-boxes common-box-shadow common-box-border common-bg-white common-br-3px">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <span className="metric-title common-Labels common-color text-uppercase">Total Patients</span>
                  <h3 className="metric-value common-FontFamily commont-Font-Bold mt-1 mb-0">
                    {dashboardData.totalPatients || 0}
                  </h3>
                </div>
                <div className="icon-wrapper bg-light p-2 rounded-circle">
                  <img src={Sells} alt="Total Patients" width="42" height="42" className="object-fit-contain" />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-xl-3">
            <div className="dashboard-boxes common-box-shadow common-box-border common-bg-white common-br-3px">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <span className="metric-title common-Labels common-color text-uppercase">Total Tests</span>
                  <h3 className="metric-value common-FontFamily commont-Font-Bold mt-1 mb-0">
                    {dashboardData.totalTests || 0}
                  </h3>
                </div>
                <div className="icon-wrapper bg-light p-2 rounded-circle">
                  <img src={Labimage} alt="Total Tests" width="42" height="42" className="object-fit-contain" />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-xl-3">
            <div className="dashboard-boxes common-box-shadow common-box-border common-bg-white common-br-3px">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <span className="metric-title common-Labels common-color text-uppercase">Total Sales</span>
                  <h3 className="metric-value common-FontFamily commont-Font-Bold mt-1 mb-0">
                    <span className="common-FontSize-small text-muted me-1">PKR</span>
                    {dashboardData.totalSell ? dashboardData.totalSell.toLocaleString() : 0}
                  </h3>
                </div>
                <div className="icon-wrapper bg-light p-2 rounded-circle">
                  <img src={Financeimage} alt="Total Sales" width="42" height="42" className="object-fit-contain" />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-xl-3">
            <div className="dashboard-boxes common-box-shadow common-box-border common-bg-white common-br-3px">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <span className="metric-title common-Labels common-color text-uppercase">Pending Tests</span>
                  <h3 className="metric-value common-FontFamily commont-Font-Bold text-warning mt-1 mb-0">
                    {dashboardData.pendingTestCount || 0}
                  </h3>
                </div>
                <div className="icon-wrapper bg-light p-2 rounded-circle">
                  <img src={pendingTest} alt="Pending Tests" width="42" height="42" className="object-fit-contain" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Charts Row 1 */}
        <div className="row g-3 mb-4">
          <div className="col-12 col-lg-6">
            <div
              id="Highchart-Container"
              className="chart-card common-box-shadow common-box-border common-bg-white common-br-3px p-3"
            ></div>
          </div>
          <div className="col-12 col-lg-6">
            <div
              id="Highchart-Daily-Container"
              className="chart-card common-box-shadow common-box-border common-bg-white common-br-3px p-3"
            ></div>
          </div>
        </div>

        {/* Charts Row 2 */}
        <div className="row g-3 mb-4">
          <div className="col-12 col-lg-6">
            <div
              id="Highchart-Progress-container"
              className="chart-card common-box-shadow common-box-border common-bg-white common-br-3px p-3"
            ></div>
          </div>
          <div className="col-12 col-lg-6">
            <div
              id="Highchart-pie-container"
              className="chart-card common-box-shadow common-box-border common-bg-white common-br-3px p-3"
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;